import type { Uri } from '@/types'

/**
 * Check if url is outside the app
 */
export function isExternalUrl(url: string) {
  return /^(http|#)/.test(url)
}

/**
 * Check if link is external
 */
export function isExternalLink(link: Uri) {
  return isExternalUrl(link.url)
}
